type EmporionSplashScreenProps = {
  label?: string
}

const EmporionSplashScreen = ({ label = 'Emporion' }: EmporionSplashScreenProps) => (
  <div className="emporion-splash" aria-live="polite" aria-busy="true">
    <div className="emporion-splash__loader" aria-hidden="true">
      <span className="emporion-splash__ring emporion-splash__ring--outer" />
      <span className="emporion-splash__ring emporion-splash__ring--inner" />
      <span className="emporion-splash__glyph">S</span>
    </div>
    <p className="emporion-splash__label">{label}</p>
  </div>
)

export default EmporionSplashScreen
